import { doesResponseMatchRequestedModel } from './modelResolver';

export interface WinnerNormalizationResult {
  normalizedWinnerId: string | null;
  matchedRequestedId: string | null;
}

interface NormalizeWinnerParams {
  winnerModelId: string | null;
  requestedModelIds?: string[] | null;
}

export function normalizeWinnerModelId({
  winnerModelId,
  requestedModelIds
}: NormalizeWinnerParams): WinnerNormalizationResult {
  if (!winnerModelId) {
    return { normalizedWinnerId: null, matchedRequestedId: null };
  }

  const requestedIds = requestedModelIds?.filter(Boolean) ?? [];
  if (requestedIds.length === 0) {
    return { normalizedWinnerId: winnerModelId, matchedRequestedId: null };
  }

  for (const requestedId of requestedIds) {
    if (requestedId === winnerModelId) {
      return { normalizedWinnerId: requestedId, matchedRequestedId: requestedId };
    }

    if (doesResponseMatchRequestedModel(requestedId, { modelId: winnerModelId, model: null })) {
      return { normalizedWinnerId: requestedId, matchedRequestedId: requestedId };
    }
  }

  return { normalizedWinnerId: winnerModelId, matchedRequestedId: null };
}
